// Styling meta for messages identified by their ID
export const messagingMeta = {
  1: {
    h1Color: "#0F172A",
    h2Color: "#64748B",
    bgcolor: "#ECFDF5"
  },
  2: {
    h1Color: "#0F172A",
    h2Color: "#64748B",
    bgcolor: "#EEF2FF"
  },
  3: {
    h1Color: "#0F172A",
    h2Color: "#64748B",
    bgcolor: "#F8FAFC"
  },
  4: {
    h1Color: "#0F172A",
    h2Color: "#64748B",
    bgcolor: "#FAF5FF"
  },
  5: {
    h1Color: "#0F172A",
    h2Color: "#64748B",
    bgcolor: "#FFF7ED"
  }
};

// Styling meta for tags identified by their key
export const tagsMeta = {
  // Status tags
  live: {
    textColor: "#0F172A",
    icon: "circle",
    iconColor: "#059669" // Green for live
    // iconType: "lucide"
  },
  under_review: {
    textColor: "#0F172A",
    icon: "circle",
    iconColor: "#f97316" // Amber for under review
    // iconType: "lucide"
  },
  closed: {
    textColor: "#94A3B8"
    // icon: "circle",
    // iconColor: "#EF4444", // Red for closed
    // iconType: "lucide"
  },
  rejected: {
    textColor: "#94A3B8",
    icon: "circle",
    iconColor: "#E11D48" // Red for closed
  },
  draft: {
    textColor: "#94A3B8"
  },
  // Feature tags
  boosted: {
    textColor: "#0F172A",
    icon: "rocket",
    iconType: "lucide"
  },
  premium: {
    textColor: "#0F172A",
    icon: "/hire/premium_tag.svg",
    iconType: "static"
  }
};

// Function to apply styling to tags from the backend
export const applyTagStyles = tags => {
  if (!tags || !Array.isArray(tags)) {
    return [];
  }

  return tags.map(tag => {
    const tagKey = tag.key;
    const styling = tagsMeta[tagKey] || {
      textColor: "text-gray-700",
      icon: "tag",
      iconType: "lucide"
    };

    return {
      ...tag,
      ...styling
    };
  });
};

// Function to apply styling to messaging from the backend
export const applyMessageStyles = messaging => {
  if (!messaging || !messaging.id) {
    return null;
  }

  const styles = messagingMeta[messaging.id];
  if (!styles) {
    return {
      ...messaging,
      h1Color: "text-gray-800",
      h2Color: "text-gray-600",
      bgcolor: "bg-gray-50"
    };
  }

  return {
    ...messaging,
    ...styles
  };
};

export default {
  messagingMeta,
  tagsMeta,
  applyTagStyles,
  applyMessageStyles
};
